import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=7cbea986&scoped=true"
import script from "./VideoElement.vue?vue&type=script&lang=js"
export * from "./VideoElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbea986",
  null
  
)

export default component.exports